module.exports = __webpack_public_path__ + "static/media/requestMoreInfoSvg.c4209b1f.webp";